var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2805 16.2422H14.7405C11.0205 16.2422 10.1805 18.1022 9.72052 20.4022L8.02051 28.5022H32.0205L30.3205 20.4022C29.8205 18.1022 29.0005 16.2422 25.2805 16.2422Z",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.26 26H14.72C11 26 8.96 26.8978 8.5 28L8 29H32L31.5 28C31 26.8978 28.98 26 25.26 26Z",
    fill: "#A020FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9875 42.816C35.1474 43.9879 33.7487 45 31.9504 45H29.133C27.5145 45 27.2947 44.5339 26.995 43.9746L26.6952 43.3753C26.2756 42.563 26.658 40.5 24.5 40.5H20H16C13.842 40.5 13.6873 42.6296 13.3077 43.3753L13.008 43.9746C12.7282 44.5472 12.5084 45 10.8699 45H8.05255C6.25422 45 4.83556 43.9879 5.0154 42.816L5.85461 36.73C6.07441 35.2252 6.49401 34 10.4303 34H29.5526C33.4889 34 33.9085 35.2252 34.1283 36.73L34.9875 42.816Z",
    fill: "#B7CCFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9803 41.7244C35.1403 43.4844 33.7402 45.0044 31.9402 45.0044H29.1202C27.5002 45.0044 27.2803 44.3044 26.9803 43.4644L26.6802 42.5645C26.2602 41.3445 25.9803 40.5044 23.8203 40.5044H16.1403C13.9803 40.5044 13.6602 41.4445 13.2802 42.5645L12.9803 43.4644C12.7003 44.3244 12.4802 45.0044 10.8402 45.0044H8.02023C6.22023 45.0044 4.80026 43.4844 4.98026 41.7244L5.82025 32.5844C6.04025 30.3244 6.46024 28.4844 10.4002 28.4844H29.5403C33.4803 28.4844 33.9002 30.3244 34.1202 32.5844L34.9803 41.7244Z",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 24H6.5",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 24H32",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11 36H15.5",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 36H29",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4203 18.4803C38.9803 17.1803 38.7802 15.4203 37.7402 13.8803C36.7202 12.3403 35.1602 11.4803 33.7402 11.5003",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6403 20.46C45.4803 17.44 44.8803 13.74 42.7403 10.54C40.6003 7.34004 37.4003 5.38 34.2803 5",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon10);
export default __webpack_public_path__ + "static/media/icon-10.5e90ba34d4ab2c5fbffe7f9f1527fce0.svg";
export { ForwardRef as ReactComponent };